import { country } from './../configuration';

// This interface uses lowercased short_name from google place api
export interface FitterHolydayZone {
  country: country;
  inCountryZone: string;
}

export interface Holyday {
  name: string; // Name given by the API, could be used as translation key
  day: string; // Format: YYYY-MM-DD
}
